import posthog from 'posthog-js'

// Analytics is prod-only and no-ops entirely when the key is absent, so local
// dev and preview builds never pollute the project data.
const KEY = import.meta.env.VITE_POSTHOG_KEY
const enabled = Boolean(KEY) && import.meta.env.PROD

export function initPosthog() {
  if (!enabled) return
  posthog.init(KEY, {
    api_host: 'https://us.i.posthog.com',
    defaults: '2025-05-24', // history_change pageviews for the SPA router, among others
    // Only logged-in reps matter (and identified-only keeps anonymous event
    // volume from counting against person-profile pricing).
    person_profiles: 'identified_only',
    session_recording: {
      // Inputs are masked by default; rendered text (customer names/phones in
      // tables) stays visible — internal tool, reps only. Revisit if replays
      // ever get shared outside the dev/supervisor circle.
      maskAllInputs: true,
    },
  })
}

export function identifyUser(user) {
  if (!enabled || !user) return
  posthog.identify(user.id, {
    email: user.primaryEmailAddress?.emailAddress,
    name: user.fullName,
  })
}

export function resetUser() {
  if (!enabled) return
  posthog.reset()
}

export default posthog
